import { ChevronRightIcon } from '@heroicons/react/solid';
import Image from 'next/image';
import Link from 'next/link';
import { FiDownload } from 'react-icons/fi';

export const Frequentlyuseddocs = () => {
  return (
    <div className="pt-20" id="freq-used-docs">
      <div className="text-center">
        <h3 className="m-auto w-[90%] text-[28px] font-[500] text-[#3d3e40] md:mb-0 md:w-auto md:text-[36px]">
          Frequently Used Documents
        </h3>
        <p className="mx-auto w-[70%] text-[17px] md:mx-0 md:w-auto md:text-[18px]">
          For purchase orders in schools and districts.
        </p>
      </div>

      <div className="mb-24 mt-6 flex flex-col items-center justify-center md:mx-24 md:mt-8 lg:mx-0 lg:flex-row lg:flex-wrap">
        <div className="relative mx-6 items-center justify-center md:mr-6 md:w-[370px] lg:w-[40%] xl:w-[27%]">
          <div className="absolute mx-7 mt-7 w-[82%] items-center md:mt-7 md:w-[85%] lg:mt-6 xl:mt-7 xl:w-[335px]">
            {/* <OptimisedImage
              defaultImagePath="/images/icons/freq-used-docs/card-accessory/card-accessory-1x.png"
              data={[
                {
                  imagePath:
                    '/images/icons/freq-used-docs/card-accessory/card-accessory-2x.png',
                  imageWidth: 1024,
                  alt: 'Card Accessory',
                },
              ]}
            /> */}
            <Image
              src="/images/icons/freq-used-docs/card-accessory/card-accessory-2x.png"
              width={1024}
              height={1024}
              alt="Card Accessory"
            />
          </div>
          <div className="mt-10 flex w-[320px] flex-col items-center justify-center rounded-3xl bg-[#F2F9FF] px-4 pb-12 pt-24 md:w-[360px] lg:w-[100%] xl:w-[390px]">
            <div className="w-[20%]">
              {/* <OptimisedImage
                defaultImagePath="/images/icons/freq-used-docs/file-folder/file-folder-1x.png"
                data={[
                  {
                    imagePath:
                      '/images/icons/freq-used-docs/file-folder/file-folder-2x.png',
                    imageWidth: 1024,
                    alt: 'File Folder',
                  },
                ]}
              /> */}
              <Image
                src="/images/icons/freq-used-docs/file-folder/file-folder-2x.png"
                width={1024}
                height={1024}
                alt="File Folder"
              />
            </div>
            <div className="flex flex-col items-center justify-center p-4">
              <h3 className="text-[28px] font-[500] text-[#3d3e40] md:text-[30px] lg:text-[36px]">
                W9 Form
              </h3>
              <p className="w-[85%] text-center text-[17px] text-[#616366] md:w-[90%] md:text-[18px]">
                Required by districts to set up as a vendor
              </p>
            </div>
            <div>
              <button
                className={
                  'mt-2 flex cursor-pointer items-center justify-center gap-x-2 self-start rounded-md border-2 border-[#318AE5] px-3 py-2 text-base font-medium text-[#318AE5]'
                }
                onClick={() =>
                  window.open('/assets/AbleSpace-W9-2024.pdf', '_blank')
                }
              >
                Download <FiDownload />
              </button>
            </div>
          </div>
        </div>

        <div className="relative mx-6 items-center justify-center md:mr-6 md:w-[370px] lg:w-[40%] xl:w-[27%] ">
          <div className="absolute mx-7 mt-7 w-[82%] items-center md:mt-7 md:w-[85%] lg:mt-6 xl:mt-7 xl:w-[335px]">
            {/* <OptimisedImage
              defaultImagePath="/images/icons/freq-used-docs/card-accessory/card-accessory-1x.png"
              data={[
                {
                  imagePath:
                    '/images/icons/freq-used-docs/card-accessory/card-accessory-2x.png',
                  imageWidth: 1024,
                  alt: 'Card Accessory',
                },
              ]}
            /> */}
            <Image
              src="/images/icons/freq-used-docs/card-accessory/card-accessory-2x.png"
              width={1024}
              height={1024}
              alt="Card Accessory"
            />
          </div>
          <div className="mt-10 flex w-[320px] flex-col items-center justify-center rounded-3xl bg-[#F2F9FF] px-4 pb-12 pt-24 md:w-[360px] lg:w-[100%] xl:w-[390px]">
            <div className="w-[20%]">
              {/* <OptimisedImage
                defaultImagePath="/images/icons/freq-used-docs/file-folder/file-folder-1x.png"
                data={[
                  {
                    imagePath:
                      '/images/icons/freq-used-docs/file-folder/file-folder-2x.png',
                    imageWidth: 1024,
                    alt: 'File Folder',
                  },
                ]}
              /> */}
              <Image
                src="/images/icons/freq-used-docs/file-folder/file-folder-2x.png"
                width={1024}
                height={1024}
                alt="File Folder"
              />
            </div>
            <div className="flex flex-col items-center justify-center p-4">
              <h3 className="text-[28px] font-[500] text-[#3d3e40] md:text-[30px] lg:text-[36px]">
                Sole Source Letter
              </h3>
              <p className="w-[85%] text-center text-[17px] text-[#616366] md:w-[90%] md:text-[18px]">
                Required by districts to set up as a vendor
              </p>
            </div>
            <div>
              <button
                className={
                  'mt-2 flex cursor-pointer items-center justify-center gap-x-2 self-start rounded-md border-2 border-[#318AE5] px-3 py-2 text-base font-medium text-[#318AE5]'
                }
                onClick={() =>
                  window.open('/assets/AbleSpace Sole Source.pdf', '_blank')
                }
              >
                Download <FiDownload />
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="my-14 flex flex-col items-center justify-center text-center md:mx-auto md:my-28 md:w-[80%] xl:w-[46%]">
        <div className="flex w-[70%]">
          {/* <OptimisedImage
            defaultImagePath="/images/icons/freq-used-docs/adv/adv_1-1x.png"
            data={[
              {
                imagePath: '/images/icons/freq-used-docs/adv/adv_1-2x.png',
                imageWidth: 1024,
                alt: 'Say goodbye to pen and paper as AbleSpace simplifies day-to-day data collection with just a click, handling the rest seamlessly.',
              },
            ]}
          /> */}
          <Image
            src="/images/icons/freq-used-docs/adv/adv_1-2x.png"
            width={1024}
            height={1024}
            alt="Say goodbye to pen and paper as AbleSpace simplifies day-to-day data collection with just a click, handling the rest seamlessly."
          />
        </div>
        <h3 className="mx-4 mt-4 text-[22px] font-[500] text-[#3d3e40] md:mt-0 md:text-[36px]">
          How is it different from other IEP systems I already have?
        </h3>
        <p className="mx-6 text-[17px] text-[#616366] md:text-[18px]">
          Other IEP systems help you author IEPs and generate compliance
          reports. But the day to day data collection is being done on pen and
          paper. This is where AbleSpace comes in. You enter data with a click,
          and AbleSpace takes care of the rest.
        </p>
        <div>
          <div className="mt-8 flex w-[100%]">
            <Link
              href="/request-quote"
              className={
                'mr-2 mt-2 flex cursor-pointer items-center gap-x-2 self-start rounded-md border-2 border-[#318AE5] bg-[#318ae5] p-3 text-base font-medium text-white hover:text-white md:py-2'
              }
            >
              Get a quote <ChevronRightIcon className="h-5 w-5" />
            </Link>
            <Link
              href="/schedule-demo"
              className={
                'mt-2 flex cursor-pointer items-center gap-x-2 self-start rounded-md border-2 border-[#318AE5] p-3 text-base font-medium text-[#318AE5] md:py-2'
              }
            >
              Schedule a Demo
            </Link>
          </div>
          <div className="mt-2 flex justify-center text-[#616366]">
            or
            <Link
              href="/contact-us"
              className="mx-1 font-semibold text-[#318ae5]"
            >
              Contact us
            </Link>
            for more information.
          </div>
        </div>
      </div>

      {/* Funding Source */}
      <div className="mx-6 mb-20 flex flex-col items-center justify-center rounded-3xl bg-[#F2F9FF] p-8 px-0 md:m-auto md:w-[90%] md:flex-row md:gap-x-6 lg:w-[85%] lg:gap-x-32 xl:w-[75%] ">
        <div className="order-2 mt-4 w-[85%] text-center md:order-1 md:ml-6 md:mt-0 md:w-[50%] md:text-left lg:ml-0 lg:w-[38%]">
          <h3 className="text-[28px] font-[500] text-[#3d3e40] md:text-[36px]">
            Funding Sources
          </h3>
          <p className="mb-8 mt-4 text-[17px] text-[#616366] md:text-[18px]">
            K-12 educational institutions, both at the school and district
            levels, have access to a range of federal and statewide
            opportunities to fund AbleSpace purchases
          </p>
          <Link
            href="/funding-opportunities"
            className={
              'mb-4 cursor-pointer items-center gap-x-2 self-start rounded-md border-2 border-[#318AE5] px-5 py-3 text-base font-medium text-[#318ae5] md:mt-2 md:py-2'
            }
          >
            Learn more...
          </Link>
        </div>
        <div className="order-1 flex w-[60%] md:order-2 md:mr-6 md:w-[40%] lg:mr-0 lg:w-[33%]">
          {/* <OptimisedImage
            defaultImagePath="/images/icons/freq-used-docs/funding-source/funding-source-1x.png"
            data={[
              // {
              //   imagePath:
              //     '/images/icons/freq-used-docs/funding-source/funding-source-1x.png',
              //   imageWidth: 0,
              //   alt: 'Funding AbleSpace purchases',
              // },
              {
                imagePath:
                  '/images/icons/freq-used-docs/funding-source/funding-source-2x.png',
                imageWidth: 1024,
                alt: 'Funding AbleSpace purchases',
              },
            ]}
          /> */}
          <Image
            src={
              '/images/icons/freq-used-docs/funding-source/funding-source-2x.png'
            }
            width={1024}
            height={1024}
            alt="Funding AbleSpace purchases"
          />
        </div>
      </div>
    </div>
  );
};
